import {
  TContactInfoUkraine,
  TPasswordUkraine,
} from "@/types/registrationUk.types";
import * as Yup from "yup";

//@ts-ignore
export const additionalInfoSchemaUk: Yup.ObjectSchema<TAdditionalInfoUkraine> =
  Yup.object().shape({
    middleName: Yup.string()
      .max(32, "validations_value_shorter_than_32_characters")
      .matches(/^[\u0400-\u04FF'\s\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_middlename"),
    dateOfBirth: Yup.string().required("validations_date_of_birth"),
    sex: Yup.object()
      .shape({
        id: Yup.boolean().required("validations_gender_required"),
        mainText: Yup.string(),
      })
      .required("validations_gender_required"),
    firstName: Yup.string()
      .max(32, "validations_shorter_than_32_characters")
      .matches(/^[\u0400-\u04FF'\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_first_name"),
    lastName: Yup.string()
      .max(32, "validations_shorter_than_32_characters")
      .matches(/^[\u0400-\u04FF'\s\-]+$/, "validations_only_cyrillic_letters")
      .required("validations_lastname_required"),
    phone: Yup.string().required("validations_phone"),
  });

//@ts-ignore
export const addressInfoSchemaUk: Yup.ObjectSchema<TAddressInfoUkraine> =
  Yup.object().shape({
    regionId: Yup.object()
      .shape({
        id: Yup.number().required("validations_region_address"),
        mainText: Yup.string(),
      })
      .required(),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required(),
    streetName: Yup.string()
      .required("validations_street_name")
      .matches(
        /^[\u0400-\u04FF0-9.\/ \-'`,]+$/,
        "validations_only_cyrillic_street_name",
      ),
    houseNumber: Yup.string()
      .matches(
        /^[\u0400-\u04FF0-9\s\/\\\-']+$/,
        "validations_only_cyrillic_letters",
      )
      .required("validations_house_number"),
    apartmentNumber: Yup.number(),
  });

export const contactInfoSchemaUk: Yup.ObjectSchema<TContactInfoUkraine> =
  Yup.object().shape({
    // firstName: Yup.string()
    //   .max(40, "validations_value_shorter_than_40_characters")
    //   .matches(/^[A-Za-z'\s]+$/, "validations_only_latin_letters")
    //   .required("validations_first_name"),
    // lastName: Yup.string()
    //   .max(40, "validations_value_shorter_than_40_characters")
    //   .matches(/^[A-Za-z'\s\-]+$/, "validations_only_latin_letters")
    //   .required("validations_lastname_required"),
    email: Yup.string().matches(
      /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
      { message: "validations_email_invalid", excludeEmptyString: true },
    ),
    phone: Yup.string()
      .required("validations_phone")
      .test(
        "phone-length",
        "validations_phone_must_be_9_digits",
        function (value) {
          if (value.startsWith("+998")) {
            const phoneDigits = value.replace(/^\+998/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+380")) {
            const phoneDigits = value.replace(/^\+380/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+1")) {
            return true;
          }
          return false;
        },
      ),
    checkTerms: Yup.boolean()
      .required("The terms and conditions must be accepted.")
      .oneOf([true], "The terms and conditions must be accepted."),
    promocode: Yup.string(),
  });

export const passwordSchemaUk: Yup.ObjectSchema<TPasswordUkraine> =
  Yup.object().shape({
    password: Yup.string().required(),
  });
